export default __webpack_public_path__ + "static/media/SKS_Diagnosis.3d06c99c.svg";